import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';

/*Component*/
import { IndexComponent }               from './index.component';
import { CourseComponent }              from './course.component';
import { FormsModule } from '@angular/forms';

/*Materials*/
import {MatIconModule, MatCardModule} from '@angular/material';
import {MatProgressSpinnerModule} from '@angular/material';
/*Lib*/
import { LazyLoadImagesModule } from 'ngx-lazy-load-images';

/*Pipe*/
import { CommentComponent }  from '../_layout/comment.component';
import { PipeShareModule }  from  '../_pipes/share.module';

/*Guard Auth*/
import { AuthGuard }    from '../_services/auth.guard';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatIconModule, 
    MatProgressSpinnerModule,
    PipeShareModule,
    LazyLoadImagesModule,
    RouterModule.forChild([
      {path: '', component: IndexComponent, canActivate: [AuthGuard]},
      {path: 'course/:id', component: CourseComponent, canActivate: [AuthGuard]},
    ])
	],
  declarations: [
    IndexComponent, 
    CourseComponent, 
    CommentComponent,
  ]
})
export class MainModule {}
